import _ from 'lodash';

export default function makePlural(item) {
	if (_.endsWith(item, 'y') || _.endsWith(item, 's')) {
		item = item.replace(/s$/g, 'ses');
		item = item.replace(/y$/g, 'ies');
	} else if (_.endsWith(item, 'x')) {
		item = item.concat('es');
	} else {
		item += 's';
	}
	return item;
}



// WEBPACK FOOTER //
// ./src/core/utils/makePlural.js